/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetSuiteCredentials } from "./NetSuiteCredentials";
import {
  NetSuiteCredentialsFromJSON,
  NetSuiteCredentialsFromJSONTyped,
  NetSuiteCredentialsToJSON,
  NetSuiteCredentialsToJSONTyped,
} from "./NetSuiteCredentials";

/**
 *
 * @export
 * @interface ReplaceNetSuiteCredentialsRequest
 */
export interface ReplaceNetSuiteCredentialsRequest {
  /**
   *
   * @type {string}
   * @memberof ReplaceNetSuiteCredentialsRequest
   */
  integrationId: string;
  /**
   *
   * @type {NetSuiteCredentials}
   * @memberof ReplaceNetSuiteCredentialsRequest
   */
  credentials: NetSuiteCredentials;
}

/**
 * Check if a given object implements the ReplaceNetSuiteCredentialsRequest interface.
 */
export function instanceOfReplaceNetSuiteCredentialsRequest(
  value: object,
): value is ReplaceNetSuiteCredentialsRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  if (!("credentials" in value) || value["credentials"] === undefined)
    return false;
  return true;
}

export function ReplaceNetSuiteCredentialsRequestFromJSON(
  json: any,
): ReplaceNetSuiteCredentialsRequest {
  return ReplaceNetSuiteCredentialsRequestFromJSONTyped(json, false);
}

export function ReplaceNetSuiteCredentialsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReplaceNetSuiteCredentialsRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
    credentials: NetSuiteCredentialsFromJSON(json["credentials"]),
  };
}

export function ReplaceNetSuiteCredentialsRequestToJSON(
  json: any,
): ReplaceNetSuiteCredentialsRequest {
  return ReplaceNetSuiteCredentialsRequestToJSONTyped(json, false);
}

export function ReplaceNetSuiteCredentialsRequestToJSONTyped(
  value?: ReplaceNetSuiteCredentialsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
    credentials: NetSuiteCredentialsToJSON(value["credentials"]),
  };
}
